import { render, staticRenderFns } from "./duplicateWindow.vue?vue&type=template&id=f7994586&scoped=true&"
import script from "./duplicateWindow.vue?vue&type=script&lang=js&"
export * from "./duplicateWindow.vue?vue&type=script&lang=js&"
import style0 from "./duplicateWindow.vue?vue&type=style&index=0&id=f7994586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7994586",
  null
  
)

export default component.exports